<div class="card address-card">
    <div class="row">
        <div class="col-sm-6">
            <h5 class="h5 font16 text-primary font-weight-bold">
                {{orderInfo.dealerName}}
            </h5>
            {{orderInfo.address}}
            <div *ngIf="!orderInfo.isDealerActive">
                <span class="text-danger font-weight-bold" translate>
                    lblInActiveDealerMessage
                </span>
            </div>
        </div>
        <div class="col-sm-6 text-right">
            <a class="h5 text-primary" (click)="showMap(Content)">
                <u class="font-weight-bold pointer">
                    <em class="fa fa-map-marker font14 mr-1"></em><span translate>lblShowInMap</span>
                </u>
            </a>
            <div>
                <table class="t-sm mt-1 font16">
                    <tr>
                        <th scope="col" class="font14">
                            <em class="fa fa-phone align-middle text-primary mr-2"></em><span translate>lblTelephone</span>
                        </th>
                        <th scope="col" class="font-weight-bold font14">
                            <a class="link-hover" href="tel:{{orderInfo.telephone}}" (click)="CallDealerLogEntry()">
                                <u>{{orderInfo.telephone}}</u>
                            </a>
                        </th>
                    </tr>
                    <tr>
                        <th scope="col" style="width: 130px;" class="font14 text-nowrap">
                            <em class="fa fa-clock align-middle text-primary mr-2"></em> <span translate>lblOpeningHours</span>
                        </th>
                        <th scope="col" ng-repeat="shiftTime in appointmentDetails.DealerShiftTime track by $index" class="ng-binding ng-scope font14 font-weight-bold">
                            {{orderInfo.openingDateTime}} - {{orderInfo.closingDateTime}}
                        </th>
                    </tr>
                </table>
            </div>
        </div>
    </div>
  </div>
  
  <ng-template #Content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" translate>{{DealerDetails.dealerName}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">
            <span aria-hidden="true" class="font18">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div id="dsw" style="min-height: auto; padding-bottom: 0">
            <div class="popup-overlay"></div>
            <div class="cst-popup popup-selecteddealermap width650">
                <div class="popup-content">
                    <div>
                        <google-map [height]="'400px'" [width]="'100%'" [center]="{lat: DealerDetails.latitude, lng: DealerDetails.longitude}" [zoom]="14">
                            <map-marker [position]="{lat: DealerDetails.latitude, lng: DealerDetails.longitude}"></map-marker>
                            <map-polyline [path]="polylinePath" [options]="polylineOptions"></map-polyline>
                        </google-map>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </ng-template>
  